<h3 mat-dialog-title>
  {{ dialogTitle }}
</h3>
<mat-dialog-content>
  @if (assignedBookingItemNameList.length > 0) {
    <div class="subtitle-help-text mb-4">
      <p>
        <strong i18n>This rule set is assigned to the following options:</strong>
      </p>
      <ul class="list-unstyled list-inline">
        @for (assignedBookingItemName of assignedBookingItemNameList; track assignedBookingItemName; let isLast = $last) {
          <li>
            {{ assignedBookingItemName }}@if (!isLast) {
            <span>,</span>
          }
        </li>
      }
    </ul>
  </div>
}
<eas-editor-eligibility-tree></eas-editor-eligibility-tree>
</mat-dialog-content>
<mat-dialog-actions>
  <div>
    @if (data.action === 'edit') {
      <button mat-flat-button color="warn" (click)="onDelete()" i18n>Delete</button>
    }
  </div>
  <div>
    <button mat-button (click)="onCancel()" i18n>Discard changes</button>
    <button mat-flat-button color="primary" (click)="onSubmit()" i18n>Apply rule</button>
  </div>
</mat-dialog-actions>
